import React, { Component } from "react";
import { connect } from "react-redux";
import { logout } from "../actions/accountActions";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";
import { withRouter } from "react-router";

class MyAccount extends Component {
    onLogout = e => {
        this.props.logout(this.props.user).then((response) => {
            const { settings } = this.props;
            if (settings && settings.allowAnonymouse === false) {
                this.props.history.push(`${settings.baseUrl}login`);
            }
        }, (error) => { });;

      
    };

    render() {
        const { t, user, settings } = this.props;
        if (!user || !user.isAuthenticated)
            return (
                <ExtendedLink className="btn btn-primary" to={`${settings.baseUrl}login`}>
                    {t("Login")}
        </ExtendedLink>
            );
        const imageUrl = user.imageUrl ? user.imageUrl : settings.defaultImageUrl;
        return (
            <div className="account account-with-name">
                <i className="icon-head" />
                <span className='account-name d-none d-md-inline-block'>{`${user.firstName} ${user.lastName} `}</span>
                <ul className="toolbar-dropdown">
                    <li className="sub-menu-user">
                        <div className="user-ava">
                            {imageUrl && <img
                                src={imageUrl}
                                alt={`${user.firstName} ${user.lastName}`}
                                className="clip-circle "
                            />}
                        </div>
                        <div className="user-info">
                            <h6 className="user-name">{`${user.firstName} ${user.lastName}`}</h6>
                            <span className="text-xs text-muted">{user.activeTotalPoints} {t("ENJO Points")}</span>
                        </div>
                    </li>
                    <li>
                        <ExtendedLink to={`${settings.baseUrl}account/profile`} >{t("My Profile")}</ExtendedLink>
                    </li>
                    <li>
                    <ExtendedLink to={`${settings.baseUrl}account/orders`} >{t("Orders List")}</ExtendedLink>
                    </li>
                    <li>
                     <ExtendedLink to={`${settings.baseUrl}account/wishlist`}>{t("Wishlist")}</ExtendedLink>
                    </li>
                    <li>
                     <ExtendedLink to={`${settings.baseUrl}account/referral`}>{t("Referral Program")}</ExtendedLink>
                    </li>
                    <li className="sub-menu-separator" />
                    <li>
                        <a  href={null} role="button" onClick={this.onLogout}>
                            <i className="icon-unlock" />{t("Logout")}
                        </a>
                    </li>
                </ul>
            </div>
        );
    }
}

function mapStateToProps({ user, settings }) {
    return { user, settings };
}

export default withRouter( withTranslation()(connect(mapStateToProps, { logout })(MyAccount)));
